"use client";

import Image from "next/image";
import { Link } from "@/i18n/navigation";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";

export default function RecentlyAddedStrip({
    slug,
    title,
    icon,
    state,
    description,
    pills = [],
}) {
    if (!slug) return null;

    return (
        <div className="mt-3 flex flex-col sm:flex-row sm:flex-wrap sm:items-stretch gap-2">
            <Link
                href={`/course/${slug}`}
                className="group flex flex-1 min-w-0 items-center gap-3 px-4 py-2.5 rounded-lg bg-gray-50 dark:bg-white/[0.03] ring-1 ring-gray-200/70 dark:ring-white/5 hover:bg-gray-100 dark:hover:bg-white/[0.06] transition-colors"
            >
                <Image
                    src={icon}
                    alt={title}
                    width={22}
                    height={22}
                    className="flex-shrink-0 rounded-md"
                />

                <p className="text-[12px] text-gray-500 dark:text-grayDark-400 mb-0 flex-1 min-w-0">
                    {state && (
                        <span className="font-medium text-gray-700 dark:text-grayDark-300">
                            {state}
                        </span>
                    )}
                    {state && " · "}
                    <span className="font-semibold text-gray-900 dark:text-white">
                        {title}
                    </span>
                    {description && (
                        <span className="hidden sm:inline text-gray-500 dark:text-grayDark-500">
                            {" : "}
                            {description}
                        </span>
                    )}
                </p>

                <SolarIcon
                    name="arrow-right-linear"
                    className="w-3.5 h-3.5 text-gray-400 dark:text-grayDark-500 flex-shrink-0 transition-transform group-hover:translate-x-0.5"
                />
            </Link>

            {pills.map((pill) => (
                <Link
                    key={pill.slug}
                    href={`/course/${pill.slug}`}
                    className="group flex items-center gap-3 px-4 py-2.5 rounded-lg bg-gray-50 dark:bg-white/[0.03] ring-1 ring-gray-200/70 dark:ring-white/5 hover:bg-gray-100 dark:hover:bg-white/[0.06] transition-colors flex-shrink-0"
                >
                    <Image
                        src={pill.icon}
                        alt={pill.title}
                        width={22}
                        height={22}
                        className="flex-shrink-0 rounded-md"
                    />
                    <p className="text-[12px] text-gray-500 dark:text-grayDark-400 mb-0 whitespace-nowrap flex-1 min-w-0">
                        {pill.state && (
                            <span className="font-medium text-gray-700 dark:text-grayDark-300">
                                {pill.state}
                            </span>
                        )}
                        {pill.state && " · "}
                        <span className="font-semibold text-gray-900 dark:text-white">
                            {pill.title}
                        </span>
                    </p>
                    <SolarIcon
                        name="arrow-right-linear"
                        className="w-3.5 h-3.5 text-gray-400 dark:text-grayDark-500 flex-shrink-0 transition-transform group-hover:translate-x-0.5"
                    />
                </Link>
            ))}
        </div>
    );
}
